export default __webpack_public_path__ + "static/media/Back.571c2747.svg";